import qs from 'qs'

import config from '@app/config'

import { ConversationsListStatus } from '@app/hooks'
import { ReplyDetectionStatus } from '@app/models'
import { communicationsApi } from '@app/services'

import { ConversationListData, FetchConversationsListResponse } from './types'
import { Conversation } from '../../models'

export const fetchConversationsList = async (
  pageCursor: string,
  pageSize: number,
  status: ConversationsListStatus[],
  replyDetectionStatus?: ReplyDetectionStatus
): Promise<ConversationListData> => {
  const lang = config.regionalSettings?.language
  const doNotTranslateFromLanguages =
    config.regionalSettings?.languageExceptions || []
  const { data } = await communicationsApi.get<FetchConversationsListResponse>(
    'conversation',
    {
      params: {
        count: pageSize,
        nextPageCursor: pageCursor,
        sort: '-updateDate',
        mode: 'Chat',
        status: status || undefined,
        replyDetectionStatus,
        getTotal: false,
        lang,
        doNotTranslateFrom: doNotTranslateFromLanguages,
      },
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: 'repeat' }),
    }
  )

  const conversations = data.conversations.filter(
    (item): item is Conversation =>
      item.participants.length > 0 && !!item.context
  )

  return { ...data, conversations }
}
